import React from "react";

import { useRegisterFormContext } from "@pages/register/hooks/useRegisterFormContext";

import { AccountDetailsForm } from "./AccountDetailsForm";

export const AccountDetails = () => {
  const { control, errors, isAmp, isCMO, isArtCentreReporter, isArtCentreRecipient, isArtist, isBeneficiary } =
    useRegisterFormContext();

  const isArtCentre = isArtCentreReporter || isArtCentreRecipient;

  const showASTI = (isArtist || isBeneficiary) && !isCMO && !isAmp;

  return (
    <AccountDetailsForm
      control={control}
      errors={errors}
      isAmp={isAmp}
      isArtist={isArtist}
      isBeneficiary={isBeneficiary}
      showASTI={showASTI}
      isCMO={isCMO}
      isArtCentre={isArtCentre}
    />
  );
};
